import React, { FC } from "react";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { CalculatorIntro } from "src/page-components/calculator/CalculatorIntro";
import { CostCalculator } from "src/page-components/calculator/CostCalculator";
import { SEO } from "src/components/SEO/SEO";
import { PATHNAMES } from "src/constants/routes";

const Calculator: FC = () => (
  <>
    <SEO
      title="Калькулятор вартості"
      description="Розрахуйте вартість індивідуального супроводу згідно організаційно-правової форми, системи оподаткування та кількості операцій у місяць"
      keywords="калькулятор вартості, розрахунок вартості послуг, бухгалтерський облік ціна, ФОП послуги, юридична особа послуги"
      url={PATHNAMES.CALCULATOR}
    />
    <PageWrapper mainClassName="p-2.5 lg:px-6 lg:pb-6 lg:pt-0">
    <div className="flex flex-col gap-5 p-5 bg-white-base rounded-2xl lg:gap-15 lg:px-20 lg:py-10 xl:px-31 xl:py-15">
      <CalculatorIntro />
      <CostCalculator />
    </div>
  </PageWrapper>
  </>
);

export default Calculator;
